import React, { useCallback, useEffect, useMemo } from 'react';
import { CheckoutButton } from '@udemy/cart-temp-migration';
import { useDeviceType } from '@udemy/hooks';
import { useFeatures } from '@udemy/react-experimentation-provider';
import { useUDData } from '@udemy/ud-data';
import { BundleUnitStore } from '../bundle-unit/bundle-unit.mobx-store';
import { SingleSelectableUnitContainer } from './single-selectable-unit-container/single-selectable-unit-container.react-component';
import { featureKeys, features, getPostAddToCartConfig } from './utils';
import styles from "./with-single-selectable-unit.react-component.module.css";
const PAGE_TYPE = 'cartSuccessModal';
export const withSingleSelectableUnit = WrappedComponent => {
  return props => {
    var _props$buyables, _buyable$id;
    const buyable = (_props$buyables = props.buyables) === null || _props$buyables === void 0 ? void 0 : _props$buyables[0];
    const buyableId = buyable === null || buyable === void 0 || (_buyable$id = buyable.id) === null || _buyable$id === void 0 ? void 0 : _buyable$id.toString();
    const udData = useUDData();
    const deviceType = useDeviceType();
    const {
      featureVariantAssignments
    } = useFeatures(featureKeys);
    const {
      isSingleSelectableUnit,
      showRelatedLabelsList,
      shouldRenderBundleUnit
    } = useMemo(() => {
      var _featureVariantAssign;
      const featureConfig = deviceType === 'desktop' && ((_featureVariantAssign = featureVariantAssignments.get(features.DESKTOP_POST_ADD_TO_CART)) === null || _featureVariantAssign === void 0 ? void 0 : _featureVariantAssign.configuration);
      return getPostAddToCartConfig(featureConfig);
    }, [deviceType, featureVariantAssignments]);
    const bundleUnitStore = useMemo(() => {
      if (isSingleSelectableUnit && shouldRenderBundleUnit && buyableId) {
        return new BundleUnitStore(PAGE_TYPE, buyableId, udData);
      }
    }, [isSingleSelectableUnit, shouldRenderBundleUnit, buyableId, udData]);
    useEffect(() => {
      if (bundleUnitStore && !bundleUnitStore.unit) {
        bundleUnitStore.fetchData();
      }
    }, [bundleUnitStore]);
    const renderSuccessHeader = useCallback(() => /*#__PURE__*/React.createElement(React.Fragment, null, buyableId && /*#__PURE__*/React.createElement(SingleSelectableUnitContainer, {
      bundleUnitStore: bundleUnitStore,
      buyable: buyable
    }), /*#__PURE__*/React.createElement("div", {
      className: styles['single-selectable-unit-button-container']
    }, /*#__PURE__*/React.createElement(CheckoutButton, {
      buttonProps: {
        className: styles['single-selectable-unit-button-container-button'],
        udStyle: 'secondary',
        size: 'large'
      },
      hideTerms: true
    }), /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, props, {
      allowAddToCartSuccessModal: false,
      className: styles['single-selectable-unit-button-container-button'],
      forceGoToCart: true,
      iconName: "cart",
      size: "large",
      udStyle: "primary"
    })))), [bundleUnitStore, buyable, buyableId, props]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, props, {
      addToCartSuccessModalProps: {
        showRelatedLabelsList,
        ...(isSingleSelectableUnit && {
          renderSuccessHeader: renderSuccessHeader
        }),
        showBundleUnit: shouldRenderBundleUnit,
        ...props.addToCartSuccessModalProps
      },
      bundleUnitStore: bundleUnitStore,
      isSingleSelectableUnit: isSingleSelectableUnit,
      shouldRenderBundleUnit: shouldRenderBundleUnit
    }));
  };
};
//# sourceMappingURL=with-single-selectable-unit.react-component.js.map